import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InformationSlice } from "redux/informationSlice/types/InformationSlice";

const informationDefaultState: InformationSlice = {};

const informationSlice = createSlice({
  name: "information",
  initialState: informationDefaultState,
  reducers: {
    toggleRelay(state, action: PayloadAction<{ imei: string }>) {
      const { imei } = action.payload;
      if (state[imei]) {
        state[imei].relay = !state[imei].relay;
      }
    },
    toggleAlarm(state, action: PayloadAction<{ imei: string }>) {
      const { imei } = action.payload;
      if (state[imei]) {
        state[imei].alarm = !state[imei].alarm;
      }
    },
    setRelay(state, action: PayloadAction<{ imei: string; value: boolean }>) {
      const { imei, value } = action.payload;
      if (state[imei]) {
        state[imei].relay = value;
      }
    },
    setAlarm(state, action: PayloadAction<{ imei: string; value: boolean }>) {
      const { imei, value } = action.payload;
      if (state[imei]) {
        state[imei].alarm = value;
      }
    },
    addTracker(
      state,
      action: PayloadAction<{ imei: string; relay: boolean; alarm: boolean }>,
    ) {
      const { imei, relay, alarm } = action.payload;
      state[imei] = { relay, alarm };
    },
  },
});

export default informationSlice;
export const informationSliceActions = informationSlice.actions;
